import { RouteRecordRawArgumented } from 'src/types/route'
import useI18n from 'src/hooks/i18n'

const { t } = useI18n()

const module: RouteRecordRawArgumented = {
  path: 'q-ricambi',
  name: 'qRicambi',
  redirect: () => ({ name: 'qRicambiIndex' }),
  children: [
    {
      path: ':step?',
      name: 'qRicambiIndex',
      component: () =>
        import(
          /* webpackChunkName: "q-ricambi-index" */ 'pages/q-ricambi/IndexPage.vue'
        ),
      meta: {
        breadcrumb: {
          name: t('breadcrumb.q_ricambi.index'),
          icon: 'mdi-car-cog',
        },
        auth: {
          permission: 'q_ricambi_access',
        },
        inject: {
          params: {
            step: 'form',
          },
        },
      },
    },
  ],
}

export default module
